module.exports = __webpack_public_path__ + "packs/media/images/stefanie_lopar_3-75dfafde4debcbbe634822c5283283de.jpg";